import { type CustomColumn } from '@/common/utils';

export const ALERT_VIEW_GRID_COLUMNS: CustomColumn[] = [
  {
    caption: 'Rule Name',
    field: 'alertRuleName',
    type: 'string',
    clickable: true,
    searchable: true,
    defaultSearchField: true,
    ignoreNameSize: true,
  },
  {
    caption: 'Tag',
    field: 'tags',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: true,
  },
  {
    caption: 'Activation',
    field: 'activation',
    type: 'string',
    width: 160,
    rendererType: 'label',
    searchable: true,
  },
  {
    caption: 'Last Alert',
    field: 'alertLevel',
    type: 'string',
    width: 160,
    rendererType: 'label',
    searchable: true,
  },
  {
    caption: 'Type',
    field: 'alertRuleType',
    type: 'string',
    searchable: true,
    width: 160,
  },
  {
    caption: 'Last Triggered',
    field: 'triggerTime',
    type: 'string',
    width: 140,
    searchable: true,
  },
  {
    caption: 'Error',
    field: 'isError',
    type: 'string',
    width: 100,
    searchable: false,
  },
  {
    caption: 'Rule ID',
    field: 'alertRuleId',
    type: 'string',
    hide: true,
    searchable: false,
  },
] as const;
